import { render, staticRenderFns } from "./prepareTextArea.vue?vue&type=template&id=a866cef2&"
import script from "./prepareTextArea.vue?vue&type=script&lang=js&"
export * from "./prepareTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports